import React from "react";
import { useNavigate } from "react-router-dom";

const AvailableDoctors = ({
   availabledoctorsData,
   isLoading }) => {
  const navigate = useNavigate();

  const getInitials = (name) => {
    if (!name) return "";
    const names = name?.trim().split(" ");
    const initials = names.map((n) => n[0]).join("").toUpperCase();
    return initials.slice(0, 2); // Only first 2 letters
  };

  // ✅ Skeleton loader
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-1 gap-6 animate-pulse">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="h-40 bg-gray-200 rounded-lg shadow-sm border-0"
          ></div>
        ))}
      </div>
    );
  }

  return (
    <>
      {availabledoctorsData?.map((item, index) => (
        <div className="col-12 mb-3" key={index}>
          <div className="card shadow-sm border-0 h-100">
            <div className="card-body">
              {/* Doctor Info */}
              <div className="d-flex align-items-center mb-3">
                {item?.profilePic ? (
                  <img
                    src={item?.profilePic}
                    alt="Doctor"
                    className="rounded-circle me-3"
                    style={{
                      width: "3rem",
                      height: "3rem",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <div
                    className="rounded-circle me-3 d-flex align-items-center justify-content-center bg-secondary text-white fw-bold"
                    style={{
                      width: "3rem",
                      height: "3rem",
                      fontSize: "1rem",
                    }}
                  >
                    {getInitials(item?.doctorName)}
                  </div>
                )}
                <div>
                  <h6 className="mb-0 fw-semibold">{item?.doctorName}</h6>
                  <small className="text-muted">{item.specialization}</small>
                </div>
              </div>

              {/* Time */}
              <div className="d-flex align-items-start mb-2">
                <i className="fa-regular fa-clock me-2 text-secondary"></i>
                <div>
                  <div className="text-muted small">
                    Available time: {item.startTime?.slice(0, 5)} AM -{" "}
                    {item.endTime?.slice(0, 5)} PM
                  </div>
                </div>
              </div>

              {/* Status */}
              <div className="d-flex align-items-start mb-3">
                <i className="fa-solid fa-business-time me-2 text-secondary"></i>
                <div className="text-muted small d-flex align-items-center">
                  Status:
                  <span
                    className={`ms-1 ${
                      item.slotStatus === "Available"
                        ? "text-success"
                        : item.slotStatus === "Few Slots Available"
                        ? "text-warning"
                        : item.slotStatus === "Fully Booked"
                        ? "text-danger"
                        : ""
                    }`}
                  >
                    {item.slotStatus}
                  </span>
                </div>
              </div>

              {/* Slots */}
              <div className="d-flex align-items-start mb-2">
                <i className="fa-solid fa-sheet-plastic me-2 text-secondary"></i>
                <div>
                  <div className="text-muted small">
                    Slots Booked: {item.bookedSlotsToday}
                  </div>
                </div>
              </div>

              {/* Action */}
              <div className="d-flex justify-content-end ">
                <button
                  className="gradient-dark-button w-100"
                  onClick={() =>
                    navigate("/AddAppointment", {
                      state: {
                        showModal: true,
                        doctorSpecialization: item?.specialization,
                        doctorName: item?.doctorName,
                        fromDoctorView: true,
                      },
                    })
                  }
                >
                  Add Appointment
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default AvailableDoctors;
